<template>
  <div class="container">
    <div class="row justify-content-center">
      <div v-if="alertMessage" class="col-md-6 p-5">
        <div v-if="alertMessage" class="alert alert-primary">
          {{ alertMessage }}
        </div>
      </div>
    </div>
    <div v-if="ready">
      <div class="row" v-for="large of larges" :key="large">
        <div v-if="widgetsList[informer[large].type]">
          <!-- {{ informer[medium].type }} -->
          <component
            :is="widgetsList[informer[large].type]"
            :info="informer[large]"
            :shares="shares[large]"
            :id="large"
          ></component>
        </div>
      </div>
      <div class="row" v-for="prox of proxmox" :key="prox">
        <div v-if="widgetsList[informer[prox].type]">
          <!-- {{ informer[medium].type }} -->
          <component
            :is="widgetsList[informer[prox].type]"
            :info="informer[prox]"
            :shares="shares[prox]"
            :id="prox"
          ></component>
        </div>
      </div>
      <!-- Medium Devices -->
      <div class="row justify-content-center m-2">
        <div v-for="medium of mediums" :key="medium" class="col-lg-2 p-0">
          <div class="border p-2" style="background-color: #fff">
            <!-- <div>{{ medium }}</div> -->
            <div v-if="widgetsList[informer[medium].type]">
              <!-- {{ informer[medium].type }} -->
              <component
                :is="widgetsList[informer[medium].type]"
                :info="informer[medium]"
                :shares="shares[medium]"
                :id="medium"
              ></component>
            </div>
          </div>
        </div>
      </div>
      <div class="row m-2 text-center" style="background-color: #fff">
        <h5 style="margin-top: 10px;">Набор тестовых виртуальных кнопок</h5>
        <div v-for="button of buttons" :key="button"  class="col-lg-3 p-0">
          <component
            :is="widgetsList[informer[button].type]"
            :info="informer[button]"
            :shares="shares[button]"
            :id="button"
            :remote="remote"
            :config="config"
          ></component>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { RemoteWeb } from "vrack-remote";
import HelloWorld from "./components/HelloWorld.vue";
import Pulsar1T from "./components/Pulsar1T.vue";
import MB210_101 from "./components/MB210_101.vue";
import MB210_204 from "./components/MB210_204.vue";
import MU210_401 from "./components/MU210_401.vue";
import Converter from "./components/Converter.vue";
import APCSmart from "./components/APCSmart.vue";
import Proxmox from "./components/Proxmox.vue";
import Button from "./components/Button.vue";

const config = {
  host: "wss://v-rack.ru/ws/",
  key: "beedb66ac0e72556",
  private: "a812a8844d42aa6ea2af75153f886cfd",
  dashboard: "g-servers",
};

export default {
  name: "App",
  data: function () {
    return {
      config: config,
      informer: false,
      dashboard: false,
      alertMessage: false,
      remote: {},
      shares: {},
      ready: false,
      mediums: [],
      larges: [],
      proxmox: [],
      buttons: [],
      widgetsList: {
        "pulsar.Pulsar1T": "Pulsar1T",
        "owen.MB210_101": "MB210_101",
        "owen.MB210_204": "MB210_204",
        "owen.MU210-401": "MU210_401",
        "tcp-service.ConverterClient": "Converter",
        "ups.APCSmart": "APCSmart",
        "proxmox.MetricVMInfo": "Proxmox",
        "logic-switch.ActionSwitch": "Button",
      },
    };
  },
  mounted: function () {
    this.connect();
  },
  components: {
    HelloWorld,
    Pulsar1T,
    MB210_101,
    MB210_204,
    MU210_401,
    Converter,
    APCSmart,
    Proxmox,
    Button,
  },
  methods: {
    async connect() {
      try {
        this.ready = false;

        this.remote = new RemoteWeb(config.host, config.key, config.private);
        this.remote.on("close", this.closed.bind(this));
        this.setMessage("Подключаюсь к VRack");
        await this.remote.connect();
        this.setMessage("Попытка авторизации");
        await this.remote.apiKeyAuth("default");
        this.setMessage("Получение основной информации");
        this.dashboard = await this.remote.commandPromise("dashboard", {
          dashboard: config.dashboard,
        });
        if (!this.dashboard.run)
          throw new Error(
            "Кажется нужная виртуальная стойка не запущена, попробуйте обратится позже"
          );

        this.informer = await this.remote.commandPromise(
          "dashboardDeviceAction",
          {
            dashboard: config.dashboard,
            action: "information",
            device: "Informer",
            push: {},
          }
        );

        await this.updateDeviceTree();

        this.ready = true;
        this.setMessage(false);
      } catch (er) {
        console.log(er)
        this.setMessage(
          "Что-то пошло не так, возможно ведутся техничиские работы на сервере"
        );
      }
    },
    async opened() {},
    async closed() {
      setTimeout(this.connect.bind(this), 5000);
    },

    async updateDeviceTree() {
      this.setMessage("Обновление древа устройств");
      this.larges = [];
      this.medium = [];
      this.proxmox = [];
      this.buttons = [];
      for (const nm in this.informer) {
        await this.remote.channelJoin(
          `dashboards.${config.dashboard}.${nm}.render`,
          (data) => {
            this.$set(this.shares, nm, data.data);
          }
        );

        switch (this.informer[nm].size) {
          case "large":
            this.larges.push(nm);
            break;
          case "medium":
            this.mediums.push(nm);
            break;
          case "proxmox":
            this.proxmox.push(nm);
            break;
          case "buttonPanel":
            this.buttons.push(nm);
            break;
        }
      }

      await this.remote.commandPromise("dashboardShares", {
        dashboard: config.dashboard,
      });
    },

    setMessage(message) {
      this.alertMessage = message;
    },
  },
};
</script>

<style>
@import "~bootstrap/dist/css/bootstrap.css";
</style>
